<template>
    <v-dialog v-model="objFormConParModal.abrirModal" max-width="80%" :scrollable="$root.isTouch == false"
        :fullscreen="$root.isTouch" persistent>
        <v-card flat>
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="objFormConParModal.titulo" />
            </v-card-title>
            <v-card-text>
                <v-form ref="form_condicion_particular" :lazy-validation="true">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Aseguradora *" color="textbox"
                                    v-model="objFormConParModal.idAseguradora" :items="listGeneralModal.listAseguradora"
                                    item-text="aseguradora" item-value="idAseguradora"
                                    @change="onListarPoliza($event,true)" :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Póliza *" color="textbox" v-model="objFormConParModal.idPoliza"
                                    :items="listGeneralModal.listPoliza" item-text="poliza" item-value="id_poliza"
                                    @change="onListarProducto($event,true)" :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Producto *" color="textbox"
                                    v-model="objFormConParModal.idProducto" :items="listGeneralModal.listProducto"
                                    item-text="nombre_producto" item-value="id_producto" :rules="requeridoRegla"
                                    outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="8">
                                <v-autocomplete label="Sección *" color="textbox" v-model="objFormConParModal.idSeccion"
                                    :items="listGeneralModal.listSeccion" item-text="seccion" item-value="idSeccion"
                                    :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Orden *" color="textbox" v-model="objFormConParModal.secOrden"
                                    :items="listGeneralModal.listOrden" item-text="orden" item-value="secOrden"
                                    :rules="requeridoRegla" :read-only="orden" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-autocomplete label="Estado *" color="textbox" v-model="objFormConParModal.idEstado"
                                    :items="listGeneralModal.listEstado" item-text="nombre_estado"
                                    item-value="id_estado" :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-expansion-panels v-model="objCkEditor.tab">
                                    <v-expansion-panel>
                                        <v-expansion-panel-header v-html="'Documento'"></v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-card flat>
                                                <v-card-text>
                                                    <ckeditor v-model="objFormConParModal.documento" :config="ckeditorConf"></ckeditor>
                                                </v-card-text>
                                            </v-card>                                            
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                        <v-row class="mt-5 mb-3">
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="cargaGeneral(false)">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="insertarActualizar">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {    
        name:'ModalCondicionParticularComponent',
        props:['listGeneral'],
        data: () => ({
                objFormConParModal: { abrirModal: false, titulo: 'Nueva Condición Particular',documento: null },
                objCkEditor: { id: 'idEditor', editor: null, tab: 0},
                ckeditorConf:{
                     language: 'es',
                },
                listGeneralModal: [],
                orden: false
        }),
        methods: {
            cargaGeneral(activo){
                if(activo){
                    this.listGeneralModal   = _.clone(_.omit(this.listGeneral,['listPoliza','listProducto']));
                    this.listGeneralModal.listEstado = _.filter(this.listGeneralModal.listEstado,(v) => { return v.visualiza == 'true' });
                    if(!this.orden){
                        this.listGeneralModal.listOrden = _.filter(this.listGeneralModal.listOrden,(v) => {

                                                                        if(_.size(_.find(this.listGeneralModal.detalle, (obj) => {
                                                                                            return parseInt(obj.secOrden) == parseInt(v.secOrden)
                                                                                                                                })
                                                                                ) == 0
                                                                        ) 
                                                                            return v;
                                                                    });
                    }

                    //editar
                    if(!_.isUndefined(this.objFormConParModal.index)){
                        this.onListarCondicionParticular('L')
                            .then((respuesta) => {
                                if(_.size(respuesta.data.data) == 0) throw respuesta.data.mensaje;
                                    return this.onListarPoliza('L');
                            })
                            .then((respuesta) => {
                                if(_.size(respuesta.data.data) == 0) throw respuesta.data.mensaje;
                                    return this.onListarProducto('L');
                            })
                            .catch((e) => {
                                mensajesAlerta(e, 'E');
                            })
                    }
                }else{
                    this.listGeneralModal   = [];
                    this.objFormConParModal = { abrirModal: false, titulo: 'Nueva Condición Particular', idEstado: _.toString(this.$parent.$parent.listParametros.idEstadoDefault)};
                    // this.objCkEditor        = { id: 'idEditor', tab: null};
                    if(!_.isUndefined(this.$refs.form_condicion_particular))
                        this.$refs.form_condicion_particular.resetValidation();

                    this.orden = false;
                }
            },
            onListarPoliza(event,isActive = false,nuevo = false){
                if(!_.isUndefined(event)){
                    var objeto = {
                                    opcion       : 'LISTAR',
                                    idAseguradora: _.get(this.objFormConParModal,'idAseguradora',null),
                                    idEstado     : _.get(this.objFormConParModal,'idEstado',null)
                                };

                    this.$set(this.listGeneralModal,'listPoliza',[]);
                    var p = this.$parent.$parent.apiSend('administrador/poliza/listar',objeto)
                                .then((respuesta) => {
                                    if(respuesta.status != 200 || respuesta.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                    if(respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                                    if(_.size(respuesta.data.data) > 0){
                                        this.$set(this.listGeneralModal,'listPoliza',respuesta.data.data);
                                    }else if(isActive)
                                        mensajesAlerta(respuesta.data.mensaje, 'I');
                                    return respuesta;
                                });
                    
                    if(isActive)
                        p.catch((e) => { mensajesAlerta(e, 'E'); });

                    return p;
                }
            },
            onListarProducto(event,isActive = false,nuevo = false){
                if(!_.isUndefined(event)){
                    var objeto = {
                                    opcion: 'L_COMBO',
                                    idAseguradora: _.get(this.objFormConParModal,'idAseguradora',null),
                                    idPoliza     : _.get(this.objFormConParModal,'idPoliza',null),
                                    idEstado     : _.get(this.objFormConParModal,'idEstado',null)
                                };

                    this.$set(this.listGeneralModal,'listProducto',[]);
                    var p = this.$parent.$parent.apiSend('administrador/producto/listar',objeto)
                                .then((respuesta) => {
                                    if(respuesta.status != 200 || respuesta.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                    if(respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                                    if(_.size(respuesta.data.data) > 0){
                                        this.$set(this.listGeneralModal,'listProducto',respuesta.data.data);
                                    }else if(isActive)
                                        mensajesAlerta(respuesta.data.mensaje, 'I');
                                    return respuesta;
                                });
                    
                    if(isActive)
                        p.catch((e) => { mensajesAlerta(e, 'E'); });

                    return p;
                }
            },
            onListarCondicionParticular(event,isActive = false){
                if(!_.isUndefined(event)){
                    var objeto = {
                                    opcion       : 'L_DETALLE',
                                    idProducto   : _.get(this.objFormConParModal,'idProducto',null),
                                    idSeccion    : _.get(this.objFormConParModal,'idSeccion',null),
                                    idEstado     : _.get(this.objFormConParModal,'idEstado',null)
                                };

                    var p = this.$parent.$parent.apiSend('administrador/condicion-particular/listar',objeto)
                                .then((respuesta) => {
                                    if(respuesta.status != 200 || respuesta.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                                    if(respuesta.data.existeError) throw mensajeEstandar.errorPeticion;
                                    if(_.size(respuesta.data.data) > 0)
                                        this.$set(this,'objFormConParModal',_.merge({},this.objFormConParModal,respuesta.data.data[0]));
                                    return respuesta;
                                });
                    
                    if(isActive)
                        p.catch((e) => { mensajesAlerta(e, 'E'); });

                    return p;
                }
            },
            insertarActualizar(){
                try {
                    if(!this.$refs.form_condicion_particular.validate()) throw mensajeEstandar.corregirInformacion;
                    if(_.size(this.objFormConParModal.documento) == 0) throw 'Debe ingresar el texto del documento de la condición particular.';
                    
                    if(_.isUndefined(this.objFormConParModal.index) || _.isNull(this.objFormConParModal.index)){
                        var l = _.find(this.$parent.$parent.listGeneral.detalle,(v) => { return parseInt(v.idSeccion) == parseInt(this.objFormConParModal.idSeccion) });
                        if(_.size(l) > 0) throw mensajeEstandar.registroExistente;
                    }
                    else{
                        var lista = _.filter(this.$parent.$parent.listGeneral.detalle,(v) => { return parseInt(v.index) != parseInt(this.objFormConParModal.index) });
                        if(_.size(_.find(lista,(v) => { return parseInt(v.idSeccion) == parseInt(this.objFormConParModal.idSeccion) })) > 0) throw mensajeEstandar.registroExistente;
                    }
                        this.$parent.$parent.objConForm = _.merge({},{opcion: _.isUndefined(this.objFormConParModal.index) ? 'I' : 'U' },_.omit(this.objFormConParModal,['abrirModal','titulo','index']));
                        this.$parent.$parent.insertarActualizar();
                } catch (error) {
                    mensajesAlerta(error, 'E');
                }
            }
        }
    }
</script>